import { useQuery } from 'query';

import { loadUserActive } from '../sources/user';
import { active } from './queryKeyFactory';

export const useUserActive = () => {
  return useQuery(
    active(),
    async () => {
      return loadUserActive();
    },
    {
      onError: () => {
        //skip error handling
      },
    }
  );
};
